<template>
  <section class="block relative z-1 rounded-lg bg-gray-200 border-0">
    <div class="px-2 md:px-4 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
          <div class="w-full lg:w-12/12 xl:w-10/12 px-4"></div>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap p-4">
      <div class="w-full xl:w-3/12 xl:mb-0 my-6">
        <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
          <div class="flex flex-wrap pr-4">
            <div
              class="w-full lg:w-12/12 px-6 py-6 rounded-lg bg-white border-0 shadow-2xl"
            >
              <div class="relative w-full mb-3"></div>
              <img
                class="align-middle border-none max-w-full h-auto rounded-lg"
                :src="NFT1_img"
              />
              <hr class="my-6" />
              <div class="text-xl mb-4"></div>
              <strong>Price: </strong> <span>3.00 ADA </span> <br />
              <strong>Royalties: </strong> <span>10% </span> <br />
              <div class="flex flex-wrap text-center justify-center">
                <a
                  href="#"
                  target="_self"
                  class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mt-6 bg-red-500 uppercase text-sm container"
                  >Remove From Sale</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full xl:w-3/12 xl:mb-0 my-6">
        <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
          <div class="flex flex-wrap pr-4">
            <div
              class="w-full lg:w-12/12 px-6 py-6 rounded-lg bg-white border-0 shadow-2xl"
            >
              <div class="relative w-full mb-3"></div>
              <img
                class="align-middle border-none max-w-full h-auto rounded-lg"
                :src="NFT1_img"
              />
              <hr class="my-6" />
              <div class="text-xl mb-4"></div>
              <strong>Price: </strong> <span>3.00 ADA </span> <br />
              <strong>Royalties: </strong> <span>10% </span> <br />

              <div class="flex flex-wrap text-center justify-center">
                <a
                  href="#"
                  target="_self"
                  class="shadow-xl font-semibold text-white px-6 py-4 rounded outline-none focus:outline-none mt-6 bg-red-500 uppercase text-sm container"
                  >Remove From Sale</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import placeholder from "@/assets/img/placeholder.svg";
import NFT1_img from "@/assets/img/Government_Bond_282781.jpg";

export default {
  data() {
    return {
      // placeholder,
      NFT1_img,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  components: {},
};
</script>
